import React, { useState, useEffect } from "react";
import FilterDropdowns from "../../components/FilterDropdowns/FilterDropdowns";
import FindGraduateSchoolsTiles from "./FindGraduateSchoolsTiles";
import { filterGraduateSchoolsEventBuilder, sendEvent } from "../../utils/event-helpers";
import { fetchResourceTilesByTagFilters, TaggedResourceTiles } from "../../utils/contentful-helpers";
import { useAppSelector } from "../../app/store";


const FindGraduateSchools = () => {
  const [taggedResourceTiles, setTaggedResourceTiles] = useState<TaggedResourceTiles[]>([]);
  const [filteredResourceTiles, setFilteredResourceTiles] = useState<TaggedResourceTiles[]>([]);
  const [selectedSubfields, setSelectedSubfields] = useState<any[]>([]);
  const [selectedDegrees, setSelectedDegrees] = useState<any[]>([]);
  
  const { userId, sessionId } = useAppSelector((state) => state.session);

  useEffect(() => {
    const tagFilters = ["Degree General Resources", "Degree Additional Resources"];
    fetchResourceTilesByTagFilters(tagFilters).then((results) => {
      setTaggedResourceTiles(results);
      setFilteredResourceTiles(results);
    });
  }, []);

  const filterTiles = (subfields: any[], degrees: any[]) => {
    const filteredTaggedResourceTiles = taggedResourceTiles.map(tile => {
      if (subfields.length === 0 && degrees.length === 0) {
        return tile;
      }
      return {
        ...tile,
        data: tile.data.filter(tile => {
          const keywords = tile.data.keyword || [];
          const matchesSubfield = subfields.length > 0
            ? subfields.some(sub => keywords.includes(sub))
            : true;
          const matchesDegree = degrees.length > 0
            ? degrees.some(deg => keywords.includes(deg))
            : true;
          return matchesSubfield && matchesDegree;
        })
      }
    });
    setFilteredResourceTiles(filteredTaggedResourceTiles);
    const allFilteredTiles = filteredTaggedResourceTiles.map(tile => tile.data).flat();
    const allTileTitles = allFilteredTiles.map(tile => tile.title);
    const eventData = filterGraduateSchoolsEventBuilder(userId, sessionId, allTileTitles, {
      degreesFilter: degrees,
      subfieldsFilter: subfields,
    });
    sendEvent(eventData);
  };

  const handleSubfieldChange = (subfields: any[]) => {
    setSelectedSubfields(subfields);
    filterTiles(subfields, selectedDegrees);
  };

  const handleDegreesChange = (degrees: any[]) => {
    setSelectedDegrees(degrees);
    filterTiles(selectedSubfields, degrees);
  };

  return (
    <>
      <div className="explore-careers">
        <div className="resources-container">
          <div className="align-headers">
            <div>
              <p
                className="career-highlighted-paragraph"
                style={{ paddingBottom: "14px", marginTop: "17px" }}
              >
                Graduate School Resources
                <span style={{ marginRight: "15.5rem" }}></span>
              </p>
            </div>

            <div className="dropdown-list">
              <div className="align-input">
                <FilterDropdowns
                  showDegree={true}
                  showSubfield={true}
                  onDegreesChange={handleDegreesChange}
                  onSubfieldsChange={handleSubfieldChange}
                />
              </div>
            </div>
          </div>
        </div>

        <div className="gap"></div>
        {/* Toggle Section Links for Mobile */}
        <div className="section-links">
          <a href="#general-resources" className="link-item">
            General Resources
          </a>
          <a href="#additional-resources" className="link-item">
            Subfield-Based Resources
          </a>
        </div>
      </div>

      <div>
        {filteredResourceTiles.map(tile => (
          <FindGraduateSchoolsTiles
            key={tile.tagFilter}
            resourceTiles={tile.data}
          />
        ))}
      </div>
    </>
  );
};

export default FindGraduateSchools;
